<template>
  <div class="leaplearner">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "layout",
};
</script>

<style lang="scss">
.leaplearner {
  width: 100%;
  background: url("../../../static/query/bg.jpg") no-repeat;
  background-size: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue